import React from 'react';
import { AudioProvider } from './context/AudioContext';
import EpisodeList from './ui/EpisodeList';
import AudioPlayer from './ui/AudioPlayer';
import './App.css';

function App() {
  return (
    <AudioProvider>
      <div className="min-h-screen bg-brand-cream selection:bg-brand-tan/30 pb-24">
        {/* Main Widget Content */}
        <main className="relative z-10 pt-4">
          <EpisodeList />
        </main>

        <AudioPlayer />

        {/* Decorative Texture (retained for subtle feel, but minimal) */}
        <div className="fixed inset-0 pointer-events-none opacity-[0.03] mix-blend-multiply bg-[url('https://www.transparenttextures.com/patterns/natural-paper.png')]"></div>
      </div>
    </AudioProvider>
  );
}

export default App;